// extracted by mini-css-extract-plugin
module.exports = {"nativeAdContainer":"styles_nativeAdContainer__2ip08"};